import globalStore from '@/services/global.state';
import {packageId} from '@/config';
import {http, imApiHttp, getDeviceCode} from '@utils';
import {RechargeCustomerItem} from '@/common-pages/im/type';
import {imManager} from '@/common-pages/im/im.state';

export enum TReportType {
  CLICK = '1',
  BETS = '2',
  REGISTER = '3',
}

// 数据上报
export type TGameType =
  | 'dice'
  | 'color'
  | '3Digit'
  | 'scratch'
  | 'matka'
  | 'kerala'
  | 'quick3d'
  | 'quickRace'
  | 'quickStateLottery'
  | 'stateLottery'
  | 'casino'
  | 'live'
  | 'sport';

export enum TSourceType {
  IM = '1',
  CHANNEL = '2',
}

export interface IReportData {
  reportType: TReportType; // 1点击 2下单 3注册
  // packageId: string;
  gameName?: string;
  gameType?: TGameType;
  userId?: string;
  inviteCode?: string;
  gameId?: string;
  issueNo?: string;
  // deviceCode?: string;
  sourceType?: TSourceType; // 1 IM 2 渠道
  channelName?: string;
  shareUserId?: string; //分享用户id
  extData?: string; //扩展数据
}

export async function postReport(data: IReportData) {
  const deviceCode = await getDeviceCode(true);
  const channelName = globalStore.isWeb ? 'h5' : 'app';
  return http.post<IReportData, null>('app/dataReport/add', {
    packageId,
    deviceCode,
    channelName,
    ...data,
  });
}

export async function getRechargeCustomers() {
  const customers =
    (await imApiHttp.get<null, RechargeCustomerItem[]>('im/zgIm/customers')) ||
    [];
  return customers.filter(item => item.status === 1);
}

// 随机获取一个指定状态的客服
function getCustomer(customers: any[], status?: string): string {
  if (status) {
    const list = customers.filter(c => c.imUserStatus === status);
    return list.length
      ? list[Math.floor(Math.random() * list.length)].imUserId
      : getCustomer(customers);
  }
  return customers[Math.floor(Math.random() * customers.length)].imUserId;
}

// 获取在线的客服并且进行跳转
export async function goToCustomerChat(balance: number | string) {
  const customers = await getRechargeCustomers();
  const rechargeCustomers = customers.filter(c => c.imCustomer === '1');
  if (rechargeCustomers.length <= 0) {
    globalStore.globalWaringTotal('No Available Customer');
    return;
  }
  imManager.setVisibleState(true, {
    amount: balance,
    customerId: getCustomer(rechargeCustomers, '1'),
  });
}
